import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Linkedin } from "lucide-react";

const TeamSection = () => {
  const navigate = useNavigate();

  const teamMembers = [
    {
      name: "Kashyap Thakkar",
      role: "Founder & Director",
      photo: "/team/kashyaap.jpeg",
      // Adding 'object-top' ensures his head isn't cut off in the circle
      position: "object-top",
      bio: "Serial entrepreneur with multiple startup exits at 6X valuations. Leads business strategy, partnerships & revenue growth with vision to build India's most trusted preventive healthcare ecosystem.",
      linkedin: "https://www.linkedin.com/in/kashyapkthakkar"
    },
    {
      name: "Yamini Dove",
      role: "Co-Founder & Director",
      photo: "/team/yamini.jpeg",
      position: "object-center",
      bio: "Dynamic professional with 8+ years operations experience, leading fulfillment, onboarding & service excellence with passion and precision.",
      linkedin: "https://www.linkedin.com/in/yamini-dove-889887224"
    }
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-white" data-testid="team-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <h2 className="text-4xl text-[#191C1D] font-extrabold tracking-wider uppercase">
            Meet Our Leadership
          </h2>
          <p className="text-gray-500 mt-2">Visionary leaders steering HealthismPlus towards excellence</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-wrap justify-center gap-10"
        >
          {teamMembers.map((member, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -8 }}
              className="bg-white rounded-[32px] overflow-hidden shadow-sm flex flex-col border border-gray-100 w-full max-w-[320px] text-center"
            >
              {/* Background Header */}
              <div className="bg-[#1A3D38] h-24 relative">
                <div className="absolute -bottom-12 left-1/2 -translate-x-1/2">
                  <img
                    src={member.photo}
                    alt={member.name}
                    /* 'object-cover' fills the circle, member.position fixes the framing */
                    className={`w-28 h-28 rounded-full border-4 border-white shadow-md object-cover ${member.position}`}
                  />
                </div>
              </div>

              <div className="pt-16 pb-8 px-6 flex flex-col items-center">
                <h3 className="text-xl font-bold text-[#091A3A] mb-1">{member.name}</h3>
                <p className="text-[#13B58E] font-semibold text-sm mb-4">{member.role}</p>
                <p className="text-xs text-[#6B7A99] leading-relaxed mb-6 line-clamp-4">
                  {member.bio}
                </p>
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#1AAC8B] text-white px-4 py-2 rounded-xl text-xs font-bold transition-all hover:bg-[#118A6A]"
                >
                  <Linkedin size={14} /> Connect on LinkedIn
                </a>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="text-center mt-12">
          <button onClick={() => navigate("/team")} className="text-sm font-semibold text-[#13B58E] hover:text-[#0e9f7a] transition">
            View All Team Members →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;